import React from "react";
import ENV from '../../configs/env.config';
function Service() {
    window.location.href = ENV.PLATFORM
    return (
        <div>
        </div>
    )
}

export default Service